export default __webpack_public_path__ + "static/media/parchmentClosed.66677943.png";